<template>
  <div>
    <h2 class="text-blue text-left text-lg font-bold mb-6">Pasos</h2>
    <div class="relative">
      <a-button
        class="btn-save-temporaly"
        shape="round"
        type="primary"
        @click="saveTemporaly"
        >GUARDAR COMO BORRADOR</a-button
      >
      <div class="w-full pr-14 my-8">
        <a-steps v-model="actualStep" class="w-full">
          <a-step v-for="item in steps" :key="item.title" />
        </a-steps>
      </div>
      <transition name="slide-fade" mode="out-in" appear>
        <Step1
            v-if="actualStep === 0"
            :saveSignal="saveSignal"
            @on-step-error="onErrorForm"
        />
        <Step2
          v-if="actualStep === 1"
          :saveSignal="saveSignal" /><Step3
          v-if="actualStep === 2"
          :saveSignal="saveSignal" /><Step4
          v-if="actualStep === 3"
          :saveSignal="saveSignal" /><Step5
          :finishing="finishing"
          :saveSignal="saveSignal"
          v-if="actualStep === 4" /><Step6
          :finishing="finishing"
          :saveSignal="saveSignal"
          v-if="actualStep === 5"
      /></transition>
    </div>

    <div class="my-8">
      <h6 v-if="actualStep !== 5" class="my-5 font-bold text-gray-500">
        Paso <span class="text-blue">{{ actualStep + 1 }}</span> de
        <span class="text-blue"> 6</span>
      </h6>
      <a-button
        class="mx-3"
        type="primary"
        ghost
        shape="round"
        @click="previous"
      >
        VOLVER</a-button
      >
      <a-button
        class="mx-3"
        type="primary"
        shape="round"
        v-if="actualStep != 5"
        @click="next"
      >
        SIGUIENTE</a-button
      >
      <a-button
        type="primary"
        shape="round"
        v-else
        @click="endRecommendation()"
      >
        FINALIZAR RECOMENDACIÓN</a-button
      >
    </div>
    <Modal v-if="showModalEndRecommendation" size="2xl" class="text-center">
      <h1 class="text-blue-dark text-center text-2xl font-bold mt-4 mb-2">
        Finalizar registro de recomendación
      </h1>
      <div class="relative">
        <span
          class="text-2xl bottom-5 absolute right-0 hover:text-gray-500"
          @click="closeModal"
          ><a-icon type="close"></a-icon>
        </span>
      </div>
      <p>
        ¿Está seguro de que se ha diligenciado de manera satisfactoria la
        recomendación?
      </p>
      <p>
        <b>RECUERDE:</b> Una vez de por aceptado el registro de esta
        recomendación, no se podrá hacer ninguna modificación de este.
      </p>

      <div class="flex gap-4 justify-center items-center my-8 mx-8">
        <BaseDate
          label="Fecha del informe"
          v-model="recommendation_date"
          disabled
        />
        <BaseInput label="Entidad" v-model="getCompany.name" disabled />
      </div>
      <div class="flex gap-3 justify-center my-5 w-2/3 mx-auto">
        <a-button type="primary" ghost shape="round" @click="saveTemporaly()">
          GUARDAR COMO BORRADOR</a-button
        >
        <a-button type="danger" ghost shape="round" @click="closeModal()"
          >CANCELAR</a-button
        >
      </div>
      <a-button class="w-2/4 mb-4" type="primary" shape="round" @click="save"
        >REGISTRAR RECOMENDACIÓN</a-button
      >
    </Modal>
    <div v-if="feedback">
      <h1 class="text-xl font-bold text-left mx-4 my-4">
        Error finalizando recomendación
      </h1>
      <p
        v-for="(feed, index) in feedback"
        :key="index"
        class="bg-red-100 rounded-xl p-4 m-2 text-left capitalize text-gray-800"
      >
        {{ feed.replace(/\[|\]/g, '"') }}
      </p>
    </div>
  </div>
</template>

<script>
import Step1 from "@/components/Dashboard/FCO/Recommendations/FormSteps/Step1.vue";
import Step2 from "@/components/Dashboard/FCO/Recommendations/FormSteps/Step2.vue";
import Step3 from "@/components/Dashboard/FCO/Recommendations/FormSteps/Step3.vue";
import Step4 from "@/components/Dashboard/FCO/Recommendations/FormSteps/Step4.vue";
import Step5 from "@/components/Dashboard/FCO/Recommendations/FormSteps/Step5.vue";
import Step6 from "@/components/Dashboard/FCO/Recommendations/FormSteps/Step6.vue";
export default {
  components: { Step1, Step2, Step3, Step4, Step5, Step6 },
  props: {
    sfc_code: { type: String, required: false },
    recommendation_code: { type: String, required: false },
  },
  data() {
    return {
      actualStep: 0,
      finishing: false,
      saveSignal: false,
      showModalEndRecommendation: false,
      optiosProducts: [],
      optionsReasons: [],
      recommendation_date: null,
      recommendation_company: "",
      feedback: null,
      steps: [
        {
          title: "1",
        },
        {
          title: "2",
        },
        {
          title: "3",
        },
        {
          title: "4",
        },
        {
          title: "5",
        },
        {
          title: "6",
        },
      ],
    };
  },
  created() {
    this.getStep();
  },
  methods: {
    onErrorForm(msg, step) {
      this.actualStep = step;
      this.feedback = []
      if (Array.isArray(msg)) {
        this.feedback.push(...msg)
      } else {
        this.feedback.push(msg)
      }
    },
    async getStep(loading = true) {
      this.loading = loading;
      let query = `?company_type=${this.getCompany.company_type}&sfc_code=${this.getCompany.sfc_code}`;
      let { error, data } = await this.$api.getRecommendations(query);
      if (data) {
        let company = data.results.filter(
          (company) => company.id == this.$route.query.recommendation_code
        )[0];
        this.recommendation_date = company.created_at;
        this.loading = false;
      }
      if (error) {
        this.showToast("error", "Ocurrió un error obteniendo la información.");
        this.loading = false;
      }
    },
    next() {
      this.actualStep++;
    },
    previous() {
      if (this.actualStep === 0)
        this.$router.push({
          name: "recommendationForm",
          query: {
            recommendation_code: this.$route.query.recommendation_code,
            id_company: this.$route.query.id_company,
          },
        });
      this.actualStep--;
    },
    endRecommendation() {
      this.finishing = true;
      this.endRecommendationConfirmation();
    },
    closeModal() {
      this.showModalEndRecommendation = false;
    },
    async save() {
      this.saveTemporaly();
      let { error, data } = await this.$api.finishRecommendation(
        this.$route.query.recommendation_code
      );
      if (error) {
        this.showToast(
          "error",
          `No es posible finalizar el recommendatione: ${error?.message}`
        );
        this.feedback = error?.data;
      } else if (data) {
        this.$router.push({
          name: "endRecommendation",
          query: {
            company_name: this.getCompany?.name,
            creation_date: this.recommendation_date,
          },
        });
        // this.showToast("success", "Informe registrado correctamente");
        // this.$router.push("dashboard/fco/recommendations");
      }
      this.finished = false;
      this.showModalEndRecommendation = false;
    },
    async endRecommendationConfirmation() {
      this.showModalEndRecommendation = true;
    },
    saveTemporaly() {
      this.saveSignal = true;
      setTimeout(() => {
        this.saveSignal = false;
      }, 1000);
      this.closeModal();
    },
    showToast(result = "info", msg) {
      this.$notification[result]({
        message: "Resultado",
        description: msg,
        onClick: () => {},
      });
    },
  },
  computed: {
    optionsCompanies: function () {
      return this.$store.state.form?.optionsCompanies?.filter(
        (item) => item?.direction == this.$store.state?.session?.user.direction
      );
    },
    getCompany: function () {
      return this.$store.state.form?.optionsCompanies?.filter(
        (item) => item?.id == this.$route.query.id_company
      )[0];
    },
  },
  watch: {},
};
</script>
<style>
.btn-save-temporaly {
  background-color: rgb(48, 157, 126);
  border-color: rgb(48, 157, 126);
  position: fixed;
  right: 4em;
  top: 19em;
  z-index: 49;
}
</style>
